// Codes of the lists served by GET /lookups?codes=... - they mirror RRZBase.Application.Dtos.Lookups.LookupCodes.
export const LOOKUP_CODES = {
  // Employee master data
  country: 'COUNTRY',
  province: 'PROVINCE',
  title: 'TITLE',
  gender: 'GENDER',
  race: 'RACE',
  maritalStatus: 'MARITAL_STATUS',
  medicalAid: 'MEDICAL_AID',
  employmentType: 'EMPLOYMENT_TYPE',
  employeeStatus: 'EMPLOYEE_STATUS',
  groupProduct: 'GROUP_PRODUCT',
  dependantType: 'DEPENDANT_TYPE',
  language: 'LANGUAGE',
  religion: 'RELIGION',

  // Affiliates and providers
  affiliateDiscipline: 'AFFILIATE_DISCIPLINE',
  affiliateDocumentType: 'AFFILIATE_DOCUMENT_TYPE',

  // Counselling intake assessment
  clientLimitationType: 'CLIENT_LIMITATION_TYPE',
  counsellingMedium: 'COUNSELLING_MEDIUM',
  counsellingType: 'COUNSELLING_TYPE',
  developmentStage: 'DEVELOPMENT_STAGE',
  fourPDimensionType: 'FOUR_P_DIMENSION_TYPE',
  fourPFactorType: 'FOUR_P_FACTOR_TYPE',
  functionalImpactSeverity: 'FUNCTIONAL_IMPACT_SEVERITY',
  patternType: 'PATTERN_TYPE',
  riskRating: 'RISK_RATING',
  riskScreeningType: 'RISK_SCREENING_TYPE',
  specialNeedType: 'SPECIAL_NEED_TYPE',
  supportServiceType: 'SUPPORT_SERVICE_TYPE',
  symptomClusterComplexityType: 'SYMPTOM_CLUSTER_COMPLEXITY_TYPE',
  workPerformanceImpactType: 'WORK_PERFORMANCE_IMPACT_TYPE',

  // The type of member of a case, the problem coding (a problem's metadata names its cluster) and the Momentum products
  memberType: 'MEMBER_TYPE',
  // The versions of the consent script: the current one is the last item
  consentScript: 'CONSENT_SCRIPT',
  // Why the main member did not authorise a dependant
  dependantDeclineReason: 'DEPENDANT_DECLINE_REASON',
  durationScale: 'DURATION_SCALE',
  severityScale: 'SEVERITY_SCALE',
  momentumProduct: 'MOMENTUM_PRODUCT',
  problemCluster: 'PROBLEM_CLUSTER',
  problem: 'PROBLEM',

  // Interventions
  assessmentType: 'ASSESSMENT_TYPE',
  closureOutcome: 'CLOSURE_OUTCOME',
  // Where a request came from, what kind it is, and the lists on the case (priority, confidentiality; risk uses riskRating)
  sourceChannel: 'INTERVENTION_SOURCE_CHANNEL',
  requestType: 'REQUEST_TYPE',
  interventionPriority: 'INTERVENTION_PRIORITY',
  confidentialityLevel: 'CONFIDENTIALITY_LEVEL',

  // Session notes
  functioningArea: 'FUNCTIONING_AREA',

  // Suicide Risk Screener answer scales
  riskScreenerFrequency: 'RISK_SCREENER_FREQUENCY',
  riskScreenerAttemptCount: 'RISK_SCREENER_ATTEMPT_COUNT',
  riskScreenerLastAttempt: 'RISK_SCREENER_LAST_ATTEMPT',
  riskScreenerIntensity: 'RISK_SCREENER_INTENSITY',
  riskScreenerPlanLikelihood: 'RISK_SCREENER_PLAN_LIKELIHOOD',
  riskScreenerContactFrequency: 'RISK_SCREENER_CONTACT_FREQUENCY',
} as const;

export type LookupCode = (typeof LOOKUP_CODES)[keyof typeof LOOKUP_CODES];

// The lists each screen needs, so a page can load everything in one request.
export const EMPLOYEE_LOOKUP_CODES: readonly LookupCode[] = [
  LOOKUP_CODES.country,
  LOOKUP_CODES.employmentType,
  LOOKUP_CODES.gender,
  LOOKUP_CODES.groupProduct,
  LOOKUP_CODES.maritalStatus,
  LOOKUP_CODES.medicalAid,
  LOOKUP_CODES.province,
  LOOKUP_CODES.race,
  LOOKUP_CODES.title,
  LOOKUP_CODES.employeeStatus,
];

export const DEPENDANT_LOOKUP_CODES: readonly LookupCode[] = [LOOKUP_CODES.title, LOOKUP_CODES.dependantType];

export const AFFILIATE_LOOKUP_CODES: readonly LookupCode[] = [
  LOOKUP_CODES.affiliateDiscipline,
  LOOKUP_CODES.language,
  LOOKUP_CODES.religion,
  LOOKUP_CODES.counsellingMedium,
  LOOKUP_CODES.gender,
  LOOKUP_CODES.province,
];

export const RISK_SCREENER_LOOKUP_CODES: readonly LookupCode[] = [
  LOOKUP_CODES.riskRating,
  LOOKUP_CODES.riskScreenerFrequency,
  LOOKUP_CODES.riskScreenerAttemptCount,
  LOOKUP_CODES.riskScreenerLastAttempt,
  LOOKUP_CODES.riskScreenerIntensity,
  LOOKUP_CODES.riskScreenerPlanLikelihood,
  LOOKUP_CODES.riskScreenerContactFrequency,
];

export const SESSION_NOTE_LOOKUP_CODES: readonly LookupCode[] = [LOOKUP_CODES.riskRating, LOOKUP_CODES.functioningArea];
